import { Component, type ReactNode } from 'react';
import { MESSAGES } from './i18n/messages';
import { downloadJson } from './settings/download';
import { STORAGE_KEY, setAsideData } from './state/storage';

const { uk, de } = MESSAGES;

interface Props {
  storage: Storage;
  children: ReactNode;
  onRestart?: () => void;
}

/**
 * DE: Fängt unerwartete Fehler ab und zeigt statt einer weißen Seite einen Ausweg in beiden Sprachen.
 * EN: Catches unexpected errors and shows a way out in both languages instead of a white page.
 */
export class AppErrorBoundary extends Component<Props, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  private readonly save = () => {
    downloadJson(this.props.storage.getItem(STORAGE_KEY) ?? '{}', 'plan-to-eating-recovery.json');
  };

  private readonly restart = () => {
    setAsideData(this.props.storage);
    (this.props.onRestart ?? (() => window.location.reload()))();
  };

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="app-page app-error">
        <h1 lang="uk">{uk.errorTitle}</h1>
        <p lang="uk">{uk.errorText}</p>
        <h1 lang="de">{de.errorTitle}</h1>
        <p lang="de">{de.errorText}</p>
        <div className="app-actions">
          <button type="button" className="app-row" onClick={this.save}>
            {`${uk.errorSave} · ${de.errorSave}`}
          </button>
          <button type="button" className="app-row" onClick={this.restart}>
            {`${uk.errorRestart} · ${de.errorRestart}`}
          </button>
        </div>
      </main>
    );
  }
}
